/** Management-only, audited resolution of an UNCERTAIN verification send. It never sends or resends anything. */
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function ReconcileSendDialog({ orderId, allocationId, onClose, onDone }) {
  const [outcome, setOutcome] = useState("");
  const [evidence, setEvidence] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async () => {
    setBusy(true); setError("");
    try {
      await api.post(`/recipient-verify/orders/${orderId}/allocations/${allocationId}/send-reconcile`, { outcome, evidence });
      toast.success(outcome === "DELIVERED" ? "Recorded as sent — no new email was sent" : "Recorded as not sent — a deliberate resend is now possible");
      onDone?.(); onClose();
    } catch (e) { setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Could not record the reconciliation"); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md z-[150]" data-testid="rv-reconcile-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">Reconcile uncertain verification email</DialogTitle>
          <DialogDescription className="text-[11px]">The email provider did not confirm this send. Check the provider log, then record what happened. Nothing is sent from here.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-[12px]">
          {[["DELIVERED", "Provider evidence shows it was sent"], ["NOT_SENT", "Provider evidence shows it was NOT sent"]].map(([v, l]) => (
            <label key={v} className="flex items-center gap-2"><input type="radio" name="rv-outcome" checked={outcome === v} onChange={() => setOutcome(v)} data-testid={`rv-reconcile-${v.toLowerCase()}`} />{l}</label>
          ))}
          <textarea value={evidence} onChange={(e) => setEvidence(e.target.value)} maxLength={500} rows={3} placeholder="Provider message ID or what you checked (10+ characters)" className="w-full rounded-md border border-slate-300 p-2" data-testid="rv-reconcile-evidence" />
          {error && <p role="alert" className="rounded-md bg-rose-50 p-2 text-rose-800" data-testid="rv-reconcile-error">{error}</p>}
        </div>
        <div className="flex justify-end gap-2">
          <Button size="sm" variant="outline" onClick={onClose}>Cancel</Button>
          <Button size="sm" disabled={busy || !outcome || evidence.trim().length < 10} onClick={submit} data-testid="rv-reconcile-submit">Record outcome</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
